import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';

@Component({
  selector: 'outlaw-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldErrorComponent {
  control = input.required<FormControl>();

  #events = toSignal(toObservable(this.control).pipe(switchMap(ctrl => ctrl.events)));

  errors = computed<string[]>(() => {
    this.#events();
    const ctrl = this.control();
    if (!ctrl.touched || !ctrl.errors) return [];

    const errs = ctrl.errors;
    const messages: string[] = [];

    if (errs['required']) {
      messages.push('This field is required');
    }

    if (errs['minlength']) {
      messages.push(`Minimum ${errs['minlength'].requiredLength} characters`);
    }

    if (errs['url']) {
      messages.push('Please enter a valid URL (e.g. https://example.com)');
    }

    if (errs['api']) {
      const apiErr = errs['api'];
      if (Array.isArray(apiErr)) {
        messages.push(...apiErr);
      } else if (typeof apiErr === 'string') {
        messages.push(apiErr);
      }
    }

    return messages;
  });
}
